/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useEffect } from "react";
import { StarIcon } from "@heroicons/react/20/solid";
import { HashLink } from "react-router-hash-link";
import ScrollReveal from "scrollreveal";
import S_profile from "../assets/images/profiles/S-profile.png";
import T_profile from "../assets/images/profiles/T-profile.png";
import C_profile from "../assets/images/profiles/C-profile.png";
import e_profile from "../assets/images/profiles/e-profile.png";
import D_profile from "../assets/images/profiles/D-profile.png";
import J_profile from "../assets/images/profiles/J-profile.png";
import A_profile from "../assets/images/profiles/A-profile.png";
import E_profile2 from "../assets/images/profiles/E-profile2.png";
import C_profile2 from "../assets/images/profiles/C-profile2.png";

const featuredTestimonial = {
  body: "Pat and his team were professional and timely from day one.  They helped us through a complicated insurance claim process which we could never have accomplished on our own. The roof that they installed was done efficiently and to our satisfaction.  Other contractors have commented that our roof was installed expertly.  High praise from others in the business confirmed our own conclusion.  We have had two roofs replaced with HighTide and would recommend them 100%!",
  author: {
    name: "Toni N.",
    rating: 5,
    imageUrl: T_profile,
  },
};

const testimonials = [
  [
    [
      {
        body: "We had a great experience with this company. Excellent crew with a lot of experience. Full replacement of our cedar shake roof was accomplished in an efficient manner. Very pleased and highly recommend HighTide Roofing",
        author: {
          name: "Dru W.",
          rating: 5,
          imageUrl: D_profile,
        },
      },
      {
        body: "I had a great experience with HighTide roofing of Wilmington.  They are very responsive, explain the process in detail, and follow through. All in all great customer service and a pleasure to work with.",
        author: {
          name: "Carel V.",
          rating: 5,
          imageUrl: C_profile,
        },
      },
      {
        body: "Love these guys! Exceptional work and all around great team! Definitely recommend their professionalism!",
        author: {
          name: "Jason",
          rating: 5,
          imageUrl: J_profile,
        },
      },
      // more testimonials here:
    ],
    [
      {
        body: "Absolutely thrilled with the incredible job done on our roof! The team was professional, efficient, and incredibly skilled. From start to finish, they handled every detail with care and expertise. Our roof looks fantastic, and we couldn't be happier with the quality of workmanship. Highly recommend their services to anyone looking for a reliable and top-notch roofing company",
        author: {
          name: "eugene s.",
          rating: 5,
          imageUrl: e_profile,
        },
      },
      // more testimonials here:
    ],
  ],
  [
    [
      {
        body: "Patrick and his crew are wonderful. They were very receptive to my concerns and provided excellent consultative feedback. I wasn’t sure if I needed a new roof but after speaking with these guys I knew I made the right decision. My home in Wrightsville Beach will live to see many more hurricane seasons",
        author: {
          name: "Shane M.",
          rating: 5,
          imageUrl: S_profile,
        },
      },
      // more testimonials here:
    ],
    [
      {
        body: "Pat is professional and the easiest to work with. Best roofer in the state!",
        author: {
          name: "Aleksandra B.",
          rating: 5,
          imageUrl: A_profile,
        },
      },
      {
        body: "Pat and his crew were great! Pat was attentive and followed through with all jobs I needed done. Very professional and committed to their work. Was very pleased and would highly recommend.",
        author: {
          name: "Evan J.",
          rating: 5,
          imageUrl: E_profile2,
        },
      },
      {
        body: "Pat and his team are the best in the business! They are professional, punctual and incredibly knowledgeable. Highly recommend!",
        author: {
          name: "Cooper H.",
          rating: 5,
          imageUrl: C_profile2,
        },
      },
      // more testimonials here:
    ],
  ],
];

function classNames(...classes: (string | boolean | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}

function Rating({ rating }: { rating: number }) {
  const totalStars = 5;
  const stars = [];
  for (let i = 0; i < totalStars; i++) {
    stars.push(
      <StarIcon
        key={i}
        aria-hidden="true"
        className={`size-5 flex-none ${
          i < rating ? "text-indigo-600" : "text-gray-300"
        }`}
      />
    );
  }
  return (
    <div className="flex items-center">
      <p className="sr-only">{rating} out of 5 stars</p>
      <div className="flex gap-x-1">{stars}</div>
    </div>
  );
}

export default function Example() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const sr = ScrollReveal({ reset: false });

      // reveal the header and subhead
      sr.reveal("#testimonials .text-center > *", {
        origin: "top",
        distance: "20px",
        duration: 600,
        interval: 150,
      });

      // reveal each testimonial card
      sr.reveal("#testimonials figure", {
        origin: "bottom",
        distance: "30px",
        duration: 700,
        interval: 200,
        delay: 300,
      });

      // reveal the "View all Google reviews" link
      sr.reveal("#testimonials a", {
        origin: "bottom",
        distance: "10px",
        duration: 500,
        delay: 800,
      });
    }
  }, []);

  return (
    <div
      id="testimonials"
      className="relative isolate bg-white pb-32 pt-24 sm:pt-32"
    >
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl"
      ></div>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-chakra_petch_sm text-base/7 font-semibold text-[#D2B48C]">
            5-STAR REVIEWS
          </h2>
          <p className="font-chakra_petch_lg mt-2 text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            WE HAVE WORKED WITH HUNDREDS OF AMAZING PEOPLE
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 grid-rows-1 gap-8 text-sm/6 text-gray-900 sm:mt-20 sm:grid-cols-2 xl:mx-0 xl:max-w-none xl:grid-flow-col xl:grid-cols-4">
          <figure className="rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/5 sm:col-span-2 xl:col-start-2 xl:row-end-1">
            <blockquote className="p-6 text-lg font-semibold tracking-tight text-gray-900 sm:p-12 sm:text-xl/8">
              <p>{`“${featuredTestimonial.body}”`}</p>
            </blockquote>
            <figcaption className="flex flex-wrap items-center gap-x-4 gap-y-4 border-t border-gray-900/10 px-6 py-4 sm:flex-nowrap">
              <img
                alt=""
                src={featuredTestimonial.author.imageUrl}
                className="size-10 flex-none rounded-full bg-gray-50"
              />
              <div className="flex-auto">
                <div className="font-semibold">
                  {featuredTestimonial.author.name}
                </div>
                <Rating rating={featuredTestimonial.author.rating} />
              </div>
            </figcaption>
          </figure>
          {testimonials.map((columnGroup, columnGroupIdx) => (
            <div
              key={columnGroupIdx}
              className="space-y-8 xl:contents xl:space-y-0"
            >
              {columnGroup.map((column, columnIdx) => (
                <div
                  key={columnIdx}
                  className={classNames(
                    (columnGroupIdx === 0 && columnIdx === 0) ||
                      (columnGroupIdx === testimonials.length - 1 &&
                        columnIdx === columnGroup.length - 1)
                      ? "xl:row-span-2"
                      : "xl:row-start-1",
                    "space-y-8"
                  )}
                >
                  {column.map((testimonial, testimonialIdx) => (
                    <figure
                      key={testimonialIdx}
                      className="rounded-2xl bg-white p-6 shadow-lg ring-1 ring-gray-900/5"
                    >
                      <blockquote className="text-gray-900">
                        <p>{`“${testimonial.body}”`}</p>
                      </blockquote>
                      <figcaption className="mt-6 flex items-center gap-x-4">
                        <img
                          alt=""
                          src={testimonial.author.imageUrl}
                          className="size-10 rounded-full bg-gray-50"
                        />
                        <div>
                          <div className="font-semibold">
                            {testimonial.author.name}
                          </div>
                          <Rating rating={testimonial.author.rating} />
                        </div>
                      </figcaption>
                    </figure>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="mt-10 flex items-center justify-center gap-x-6 pt-6">
          <HashLink
            smooth
            to="https://www.google.com/search?hl=en-US&gl=us&q=Hightide+Roofing,+4608+Mockingbird+Ln,+Wilmington,+NC+28409&ludocid=6352782261069190851&lsig=AB86z5WHmWOqpJY3zBULYgzSOQgo#lrd=0x89a9f5d3c4abcbab:0x58299dced66e96c3,1,,,,"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-md bg-red-700 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            View all Google reviews
          </HashLink>
        </div>
      </div>
    </div>
  );
}
